import styled, { css } from 'styled-components'

export const Header = styled.div`
    display: flex;
    flex-wrap: wrap;

    .title {
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        align-self: center;

        span {
            font-weight: 700;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.02em;
            color: var(--gray-800);
        }
    }
`

export const SelectWrapper = styled.div`
    .live-select {
        margin-bottom: 3px !important;
        width: 224px;
        max-width: 224px;
    }

    .equipment-link {
        color: #1890ff;
        text-decoration: none;
        font-size: 12px;
        margin-left: 5px;
        align-self: flex-start;

        &:hover {
            text-decoration: underline;
        }
    }

    .no-equipment-selected {
        color: gray;
        font-size: 12px;
        margin-left: 3px;
        margin-bottom: 1px;
    }

    .Select-control {
        border-radius: 4px;

        .Select-value > .Select-value-label > div[title] {
            font-size: 13px;
            font-weight: 400;
        }
    }

    .Select-arrow {
        border-color: #37a3ef transparent transparent;
    }

    .Select.is-open > .Select-control .Select-arrow {
        border-color: transparent transparent #37a3ef;
    }

    .Select.is-disabled > .Select-control {
        background-color: var(--gray-200);

        .Select-arrow {
            border-color: var(--gray-600) transparent transparent;
        }

        .Select-value > .Select-value-label > div[title] {
            color: var(--gray-600);
        }
    }

    input {
        border: 1px solid var(--gray-400);
    }

    span.Select-value-label {
        line-height: 34px !important;
    }

    .Select-placeholder {
        font-size: 12px !important;
        font-weight: 500 !important;
    }

    @media only screen and (max-width: 1146px) {
        .live-select {
            margin-bottom: 2px !important;
            width: 195px;
            max-width: 195px;
        }
    }
`

export const StartButton = styled.button<{ liveTheme?: string }>`
    ${({ liveTheme }) =>
        liveTheme === 'dark'
            ? css`
                  &:disabled {
                      opacity: 1 !important;
                      border: 1px solid var(--blue-200);
                      background-color: var(--blue-200);

                      i,
                      span {
                          color: var(--gray-600);
                      }
                  }
              `
            : css`
                  &:disabled {
                      opacity: 1 !important;
                      border: 1px solid var(--blue-400);
                      background-color: var(--blue-400);

                      i,
                      span {
                          color: var(--blue-200);
                      }
                  }
              `}

    display: flex;
    align-items: center;
    gap: 8px;

    height: 36px;
    width: 95px;
    padding: 4px 16px;

    border: 1px solid var(--blue-500);
    border-radius: 4px;

    font-weight: 600;

    cursor: pointer;

    background-color: var(--blue-500);

    i,
    span {
        color: white;
    }
`

export const StopButton = styled.button`
    display: flex;
    align-items: center;
    gap: 8px;

    height: 36px;
    width: 95px;
    padding: 4px 16px;

    border: 1px solid var(--gray-400);
    border-radius: 4px;

    cursor: pointer;

    color: var(--gray-900);
    background-color: transparent;

    a:hover {
        color: var(--gray-800);
    }

    span {
        font-size: 13px;
        font-weight: 600;
    }
`
